	export const UNASSIGN_TEXT = 'Are you sure you want to unassign reference template from this network element?';
	export const ASSIGN_TEXT = 'Are you sure you want to assign/reassign reference template?';
	export const REASSIGN_TEXT = 'Are you sure you want to reassign reference template?';

	export const bulkAssignActions = {
		assignTemplate: 'assignTemplate',
		unassignTemplate: 'unassignTemplate',
	};
